module.exports = __webpack_public_path__ + "static/media/mira_search_prototype_laptop.65cddb7a.png";